import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResetPasswordRQ } from 'src/main/webapp/assets/models/reset.password';
import { environment } from 'src/main/webapp/environments/environment';

/**
 * Servizio per il reset password (sia richiesta, sia cambio password)
 */
@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService {
  constructor(private readonly httpClient: HttpClient) { }

  public sendResetPasswordToken(emailAddress: string) {
    const url = `${environment.backend.resetpassword.request}?emailAddress=${emailAddress}`;

    return this.httpClient.get(url, {
      observe: 'response',
      responseType: 'text'
    });
  }

  public resetPassword(resetPasswordRequest: ResetPasswordRQ): Observable<any> {
    return this.httpClient.post(environment.backend.resetpassword.confirm, resetPasswordRequest, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      observe: 'response',
      responseType: 'text'
    });
  }

}
